import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import WinterNav from '../components/WinterNav';
import WinterFooter from '../components/WinterFooter';

import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Wintersense"
      meta={[
        { name: 'description', content: 'An Internet of Things approach to sensing Road Surface Temperatures. Our sensors are non-invasive, low-cost and provide real-time data using wireless communications.' }
      ]}
    />

    <WinterNav />

    {children()}

    <WinterFooter />

  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js